<template>
    <div>
        <div class="menu-logo" v-if="titleInfo">
            <img
                v-if="titleInfo && titleInfo.logo"
                :src="titleInfo.logo"
                alt=""
                class="img"
            />
            <div v-show="!isCollapse" class="title">
                {{ titleInfo.title }}
            </div>
        </div>
        <el-scrollbar wrap-class="scrollbar-wrapper">
            <transition>
                <el-menu
                    class="menu-container"
                    background-color="#2e323f"
                    active-text-color="#ff3037"
                    text-color="#a3a4a5"
                    :collapse="isCollapse"
                    :default-active="defaultActive"
                    :default-openeds="openKeys"
                    @select="handleSelect"
                >
                    <template v-for="item in routers">
                        <sub-menu
                            v-if="!item.hide"
                            :key="item.id"
                            :routeInfo="item"
                            :basePath="item.path"
                            :onRouter="handleRouteChange"
                        />
                    </template>
                </el-menu>
            </transition>
        </el-scrollbar>
    </div>
</template>
<script>
import { sidebarHighlight } from '@/utils/sidebar-highlight';
import { mapGetters } from 'vuex';
import SubMenu from './sub-menu.vue';
import { titleInfo } from '@/common/config';
import { constantsRouters } from '@/common/router';

export default {
    name: 'Menu',
    components: {
        SubMenu
    },
    data() {
        return {
            defaultActive: '',
            oldDefaultActive: '',
            openKeys: [],
            titleInfo: undefined
        };
    },
    computed: {
        ...mapGetters(['permissionRouters', 'isCollapse']),
        routers: function() {
            return constantsRouters.concat(this.permissionRouters);
        }
    },
    created() {
        const userInfo = this.$store.getters.userInfo;
        this.titleInfo = titleInfo[userInfo.tenantType || 2];
    },
    mounted() {
        this.setSidebarHighlight();
    },
    methods: {
        // 设置高亮
        setSidebarHighlight(path = this.$route.path) {
            const res = sidebarHighlight(path);
            this.openKeys = res.openKeys || [];
            this.defaultActive = res.selectedKey || '';
        },
        // 监听侧边栏变化
        handleRouteChange(route) {
            if (route.action === 'cancel') {
                if (this.oldDefaultActive) {
                    this.defaultActive = this.oldDefaultActive;
                }
                return;
            }
            this.openKeys.push(route.id);
            this.defaultActive = route.id;
            this.$emit('router-change', route.internal);
        },
        handleSelect() {
            this.oldDefaultActive = this.defaultActive;
            // 先清空选中状态, 否则el-menu无法触发内部defaultActive的watch函数
            this.defaultActive = '';
        }
    }
};
</script>
<style lang="scss" scoped>
.menu-logo {
    display: flex;
    align-items: center;
    padding: 29px 0 29px 22px;
    .img {
        height: 21px;
    }
    .title {
        margin-left: 5px;
        font-size: 16px;
        line-height: 18px;
        color: #fff;
        font-weight: 700;
    }
}
.el-scrollbar {
    height: calc(100% - 80px);
    .menu-container {
        border-right: 0;
    }
    // 侧边栏展开式的样式调整
    ::v-deep {
        .el-menu-item,
        .el-submenu__title {
            height: 40px;
            line-height: 40px;
            margin-bottom: 5px;
        }
        .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
            color: #fff;
        }
        .el-submenu .el-menu-item {
            min-width: auto;
        }
        .el-submenu .el-menu-item.is-active {
            position: relative;
            &::after {
                content: '';
                display: block;
                width: 4px;
                height: 20px;
                background: #ff3037;
                position: absolute;
                top: 50%;
                right: 4px;
                margin-top: -10px;
                opacity: 1;
                transform: scale(1);
                border-radius: 2px;
            }
        }
        .el-submenu__title {
            color: #ddd !important;
        }
        // 侧边栏收起时的样式调整
        .el-menu--collapse .el-submenu.is-active .el-submenu__title {
            position: relative;
            &::after {
                content: '';
                display: block;
                width: 4px;
                height: 20px;
                background: #ff3037;
                position: absolute;
                top: 50%;
                right: 4px;
                margin-top: -9px;
                opacity: 1;
                transform: scale(1);
                border-radius: 2px;
            }
        }
    }
}
</style>
